module.exports = __webpack_public_path__ + "static/media/Residential_49.29200995.jpg";